/** Inclusive service-date window, as `yyyy-MM-dd`, in which a procedure code may be billed. */
export interface ProcedureCodeEffectiveWindow {
  effectiveFrom?: string;
  effectiveThrough?: string;
}

/** 2027 CPT maternity codes that replace the global maternity codes. */
export const PROCEDURE_CODES_EFFECTIVE_2027 = [
  "59080",
  "59081",
  "59082",
  "59083",
  "59431",
  "59432",
  "59433",
  "59434",
  "59502",
  "59503",
] as const;

/** Global maternity codes, billable for service dates through 12/31/2026. */
export const GLOBAL_MATERNITY_CODES_RETIRING_2027 = [
  "59400",
  "59410",
  "59425",
  "59426",
  "59430",
  "59610",
] as const;

export const PROCEDURE_CODE_EFFECTIVE_WINDOWS: Readonly<
  Record<string, ProcedureCodeEffectiveWindow>
> = {
  ...Object.fromEntries(
    PROCEDURE_CODES_EFFECTIVE_2027.map((code) => [code, { effectiveFrom: "2027-01-01" }]),
  ),
  ...Object.fromEntries(
    GLOBAL_MATERNITY_CODES_RETIRING_2027.map((code) => [code, { effectiveThrough: "2026-12-31" }]),
  ),
};
